// ---------------------------------------------------------
// LEGACY SAFE AUTO-ADD SCRIPT (ES5 Compatible)
// Works on Old iPhones, IE11, and older Androids
// ---------------------------------------------------------
document.addEventListener('DOMContentLoaded', function() {
  var config = {
    variantId: 52424004174170, // Your Gift Box Variant ID
    debug: false
  };

  var isUpdating = false;
  var checkTimeout = null;

  // 1. Run immediately on load
  checkCartAndAdjust();

  // 2. Monitor FETCH (for modern themes) - purely optional check
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function() {
      var args = arguments;
      return originalFetch.apply(this, args).then(function(response) {
        if (args[0] && typeof args[0] === 'string' &&
            (args[0].indexOf('/cart/add') > -1 || args[0].indexOf('/cart/update') > -1 || args[0].indexOf('/cart/change') > -1) &&
            !isUpdating) {
          triggerDebouncedCheck();
        }
        return response;
      });
    };
  }

  // 3. Monitor XHR (for older devices/jQuery)
  // We safeguard these overrides to ensure we don't break older browsers
  var originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };

  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    var self = this;
    this.addEventListener('load', function() {
      if (self._url &&
          (self._url.indexOf('/cart/add') > -1 || self._url.indexOf('/cart/update') > -1 || self._url.indexOf('/cart/change') > -1) &&
          !isUpdating) {
        triggerDebouncedCheck();
      }
    });
    return originalSend.apply(this, arguments);
  };

  function triggerDebouncedCheck() {
    if (checkTimeout) clearTimeout(checkTimeout);
    checkTimeout = setTimeout(checkCartAndAdjust, 1000);
  }

  // --- HELPER: Universal AJAX function (Replaces Fetch) ---
  function ajaxRequest(method, url, data, successCallback, errorCallback) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    // Shopify specific header to identify ajax requests
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

    xhr.onload = function() {
      if (xhr.status >= 200 && xhr.status < 400) {
        var resp = xhr.responseText;
        try {
          var json = JSON.parse(resp);
          if (successCallback) successCallback(json);
        } catch (e) {
          if (errorCallback) errorCallback(e);
        }
      } else {
        if (errorCallback) errorCallback(xhr);
      }
    };

    xhr.onerror = function() {
      if (errorCallback) errorCallback(xhr);
    };

    xhr.send(data ? JSON.stringify(data) : null);
  }

  function checkCartAndAdjust() {
    var cartUrl = (window.Shopify.routes.root || '/') + 'cart.js?v=' + new Date().getTime();

    ajaxRequest('GET', cartUrl, null, function(cart) {
      var isTargetInCart = false;
      var hasPhysicalProduct = false;

      // Using simple for-loop instead of forEach for maximum compatibility
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];

        if (item.id === config.variantId || item.variant_id === config.variantId) {
          isTargetInCart = true;
        }

        var type = item.product_type ? item.product_type.toLowerCase() : '';
        var isGiftCard = item.gift_card === true || type.indexOf('gift card') > -1;

        if (!isGiftCard && item.id !== config.variantId && item.variant_id !== config.variantId) {
          hasPhysicalProduct = true;
        }
      }

      if (config.debug) console.log('Cart Scan:', { hasPhysicalProduct: hasPhysicalProduct, isTargetInCart: isTargetInCart });

      if (hasPhysicalProduct && !isTargetInCart) {
        updateCart('add', config.variantId);
      } else if (!hasPhysicalProduct && isTargetInCart) {
        updateCart('remove', config.variantId);
      }
    });
  }

  function updateCart(action, id) {
    isUpdating = true; // Lock

    var endpoint = action === 'add' ? '/cart/add.js' : '/cart/update.js';
    var data = {};

    if (action === 'add') {
      data.items = [{ id: id, quantity: 1 }];
    } else {
      data.updates = {};
      data.updates[id] = 0;
    }

    var url = (window.Shopify.routes.root || '/') + endpoint;
    // Remove leading double slash if present due to concatenation
    url = url.replace('//cart', '/cart');

    ajaxRequest('POST', url, data, function(response) {
      // Unlock
      setTimeout(function() { isUpdating = false; }, 500);

      if (window.location.pathname.indexOf('/cart') > -1) {
         window.location.reload();
      } else {
         if(config.debug) console.log('Cart updated background');
         refreshMiniCartUI();
      }
    }, function(err) {
      isUpdating = false; // Unlock on error
      if(config.debug) console.error('Error updating cart', err);
    });
  }

  function refreshMiniCartUI() {
     // Old browser safe event dispatching
     try {
       document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
       document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
     } catch (e) {
       // Fallback for very old browsers that don't support new CustomEvent constructor
       var evt = document.createEvent('CustomEvent');
       evt.initCustomEvent('cart:refresh', true, true, {});
       document.documentElement.dispatchEvent(evt);
     }
  }
});
